<!--MODAL RELATORIOS-->
<div id='modal-relatorios' class="modal full fade" tabindex="-1" role="dialog" aria-labelledby="myExtraLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header justify-content-between">
        <h5 class="modal-title" id="exampleModalCenterTitle">Relatóriosssss</h5>
        <img class="bt-fechar" data-bs-dismiss="modal" src="assets/img/icon_bt-limpar_header.svg">
      </div>
      <div class="modal-body p-0">
        <div id='conteudo-relatorios'>
          <div id='relatorios' class="bg-white" >
            <h3>Relatórios</h3>
            <app-relatorios-dashboard-card [card]="false" ></app-relatorios-dashboard-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
